// Лентата с търсачката на листа „Доставка": голямата търсачка + „Целият
// списък" + „Нов продукт" (името се попълва от написаното).
import type { ComponentProps } from "react";
import { AppstoreOutlined, PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { SECONDARY_BUTTON_CLASS } from "../../components/list/buttonStyles";
import { DeliveryWorksheetSearch } from "./DeliveryWorksheetSearch";

type Props = {
  search: ComponentProps<typeof DeliveryWorksheetSearch>;
  onOpenCatalog: () => void;
  onNewProduct: () => void;
};

export const DeliverySearchBar = ({ search, onOpenCatalog, onNewProduct }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="min-w-0 flex-1">
        <DeliveryWorksheetSearch {...search} />
      </div>
      <button type="button" onClick={onOpenCatalog} className={`${SECONDARY_BUTTON_CLASS} !py-[9px]`}>
        <AppstoreOutlined />
        {t("inventoryPage.catalogOpen")}
      </button>
      <button type="button" onClick={onNewProduct} className={`${SECONDARY_BUTTON_CLASS} !py-[9px]`}>
        <PlusOutlined />
        {t("inventoryPage.productAdd")}
      </button>
    </div>
  );
};

export default DeliverySearchBar;
